import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useCustomNavigate from "./../../hooks/useCustomNavigate";
import axios from "./../../services/http";
import HeaderComponent from './../../modules/Shared/components/HeaderComponent';
import TablaNoFiscal from "./TablaNoFiscal";
import ModalAddPaymentCredit from "./../../modules/Shared/modals/ModalAddPaymentCredit";
import { Breadcrumb, Layout, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
const { Content } = Layout;

const LayoutNoFiscal = () => {

    const navigate = useCustomNavigate();
    const location = useLocation();
    const { from } = location.state;
    const [loading, setLoading] = useState(true);
    const [relationships, setRelationships] = useState([]);
    const [openPaymentCreditDialog, setOpenPaymentCreditDialog] = useState(false);

    useEffect(() => {
        fetchGetRelationshipsGroup();
    }, [from]);

    const fetchGetRelationshipsGroup = async () => {
        try {
            const response = await axios.HTTP_GET(`/api/v1/relationship/get-payments/${from.id}/No Fiscal/PAYMENTSCP`, null, navigate);
            response.map((item, index) => {
                if (!item.saldo) item.saldo = 0;
                if (index === 0 && item.tipo === "ABONO_CREDITO") item.saldo = item.abono;
                else if (index === 0 && item.tipo !== "ABONO_CREDITO") item.saldo = (item.abono ? item.abono : 0) - item.retiro;
                else {
                    item.saldo = (response[index - 1].saldo + (item.abono ? item.abono : 0)) - (item.retiro ? item.retiro : 0);
                }
                return item;
            });
            setRelationships(response);
        } catch (error) {
            console.error('Error al cargar los montos no fiscales:', error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    {/** FUNCTIONS MODAL ADD PAYMENT CREDIT **/ }
    const cancelPaymentCreditDialog = () => setOpenPaymentCreditDialog(false);
    const savedPaymentCredit = () => {
        setOpenPaymentCreditDialog(false);
        fetchGetRelationshipsGroup();
    }

    return (
        <>
            <Layout>
                <Content
                    className='primary-container'
                >
                    <Breadcrumb
                        className='breadcrumb'
                        items={[
                            { title: <a href="/home">Inicio</a> },
                            { title: "Tabla No Fiscal" }
                        ]}
                    />

                    <HeaderComponent title={`Tabla No Fiscal - ${from.nombre_obra}`} />
                    <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                        <Button type="primary" shape="round"
                            style={{ "marginBottom": "15px" }}
                            onClick={() => setOpenPaymentCreditDialog(true)}
                        >
                            <PlusOutlined /> Nuevo abono
                        </Button>
                    </div>

                    <div>

                        <TablaNoFiscal
                            relationships={relationships}
                            loading={loading}
                        />

                    </div>
                </Content>
            </Layout>

            {/** INIT MODAL ADD PAYMENT CREDIT **/}
            <ModalAddPaymentCredit
                obraId={from.id}
                title={`Nuevo Abono - ${from.nombre_obra}`}
                openPaymentCreditDialog={openPaymentCreditDialog}
                cancelPaymentCreditDialog={cancelPaymentCreditDialog}
                savedPaymentCredit={savedPaymentCredit}
                typeAmount="No Fiscal"
            />
            {/** END MODAL ADD PAYMENT CREDIT **/}
        </>
    )
}

export default LayoutNoFiscal;